import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefreshWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.24094 9.2831C6.13457 9.2831 6.0282 9.26537 5.92182 9.21219C5.56725 9.0349 5.44315 8.60942 5.62044 8.25485C6.91462 5.75512 9.48526 4.19501 12.2864 4.19501C14.3429 4.19501 16.2753 5.02825 17.6758 6.46427V4.70914C17.6758 4.31911 17.995 4 18.385 4C18.775 4 19.0941 4.31911 19.0941 4.70914V7.91801C19.0941 8.68033 18.4736 9.30083 17.7113 9.30083H14.4847C14.0947 9.30083 13.7756 8.98172 13.7756 8.59169C13.7756 8.20166 14.0947 7.88255 14.4847 7.88255H17.0376C15.8853 6.44654 14.1479 5.59557 12.2864 5.59557C10.0171 5.59557 7.94288 6.85429 6.87917 8.89307C6.73734 9.14127 6.48914 9.2831 6.24094 9.2831ZM17.7822 14.3712C17.9418 14.0166 18.3673 13.8571 18.7218 14.0343C19.0764 14.1939 19.236 14.6194 19.0587 14.974C17.7822 17.5978 15.1938 19.2288 12.2864 19.2288C10.1235 19.2288 8.10243 18.2715 6.68415 16.6936V18.5374C6.68415 18.9274 6.36504 19.2465 5.97501 19.2465C5.58498 19.2465 5.26587 18.9274 5.26587 18.5374V15.2931C5.26587 14.5485 5.86864 13.9457 6.61324 13.9457H9.87529C10.2653 13.9457 10.5844 14.2648 10.5844 14.6548C10.5844 15.0449 10.2653 15.364 9.87529 15.364H7.39329C8.54565 16.9064 10.354 17.8283 12.2864 17.8283C14.6443 17.8283 16.754 16.4986 17.7822 14.3712Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0",
			"mask-type": "alpha",
			maskUnits: "userSpaceOnUse",
			x: 5,
			y: 4,
			width: 15,
			height: 16,
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.24094 9.2831C6.13457 9.2831 6.0282 9.26537 5.92182 9.21219C5.56725 9.0349 5.44315 8.60942 5.62044 8.25485C6.91462 5.75512 9.48526 4.19501 12.2864 4.19501C14.3429 4.19501 16.2753 5.02825 17.6758 6.46427V4.70914C17.6758 4.31911 17.995 4 18.385 4C18.775 4 19.0941 4.31911 19.0941 4.70914V7.91801C19.0941 8.68033 18.4736 9.30083 17.7113 9.30083H14.4847C14.0947 9.30083 13.7756 8.98172 13.7756 8.59169C13.7756 8.20166 14.0947 7.88255 14.4847 7.88255H17.0376C15.8853 6.44654 14.1479 5.59557 12.2864 5.59557C10.0171 5.59557 7.94288 6.85429 6.87917 8.89307C6.73734 9.14127 6.48914 9.2831 6.24094 9.2831ZM17.7822 14.3712C17.9418 14.0166 18.3673 13.8571 18.7218 14.0343C19.0764 14.1939 19.236 14.6194 19.0587 14.974C17.7822 17.5978 15.1938 19.2288 12.2864 19.2288C10.1235 19.2288 8.10243 18.2715 6.68415 16.6936V18.5374C6.68415 18.9274 6.36504 19.2465 5.97501 19.2465C5.58498 19.2465 5.26587 18.9274 5.26587 18.5374V15.2931C5.26587 14.5485 5.86864 13.9457 6.61324 13.9457H9.87529C10.2653 13.9457 10.5844 14.2648 10.5844 14.6548C10.5844 15.0449 10.2653 15.364 9.87529 15.364H7.39329C8.54565 16.9064 10.354 17.8283 12.2864 17.8283C14.6443 17.8283 16.754 16.4986 17.7822 14.3712Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0)",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		})
	]
});
export default SvgRefreshWhite;
